export default "__VITE_ASSET__Bqh6oYPB__"